
import { Link } from 'react-router-dom';
import { PageMeta } from '../../components/shared/PageMeta';
import { LegalPageLayout, LegalSection } from '../../components/feature/LegalPageLayout';
import { LEGAL_LAST_UPDATED } from '../../content/legalDates';

export default function TermsPage() {
  return (
    <LegalPageLayout title="Terms of Service" lastUpdated={LEGAL_LAST_UPDATED.terms}>
      <PageMeta path="/terms" />
      <LegalSection title="Who we are">
        <p>
          driscop.co.uk is operated by Driscop Ltd, a company registered in England and
          Wales (company number 16487052), registered office 6 Hall Grove, Manchester,
          M14 5HU. By using this site, you agree to these terms.
        </p>
      </LegalSection>

      <LegalSection title="Using this site">
        <p>
          This site is informational. It describes Driscop's products and services and may
          offer forms, self-assessment tools, or other interactive features from time to
          time.
        </p>
        <p>
          Any self-assessment or awareness tool on this site is educational. It is not a
          professional security assessment, does not scan your accounts or devices, and its
          results should not be treated as a guarantee of your organisation's security
          posture.
        </p>
      </LegalSection>

      <LegalSection title="Forms">
        <p>
          Submitting a form on this site does not create a contract between you and
          Driscop, and does not guarantee access to any current or future product. We may
          contact you using the details you provide for the purpose you gave them to us, as
          described in our{' '}
          <Link to="/privacy" className="text-blue-400 hover:text-blue-300">
            Privacy Policy
          </Link>
          . Please give us accurate information; we may remove submissions that are false,
          abusive, or spam.
        </p>
      </LegalSection>

      <LegalSection title="Acceptable use">
        <p>You agree not to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Use this site for any unlawful purpose or in a way that could damage or overburden it;</li>
          <li>Attempt to gain unauthorised access to this site, its data, or the systems behind it;</li>
          <li>Scrape, copy, or reuse the content of this site without our permission;</li>
          <li>Submit false, misleading, or malicious information through any form.</li>
        </ul>
      </LegalSection>

      <LegalSection title="Intellectual property">
        <p>
          The Driscop name, logo, and the content of this site (text, design, and graphics)
          belong to Driscop Ltd or our licensors, unless stated otherwise. You may view and
          print pages for your own personal or internal business use, but may not
          reproduce, republish, or redistribute them without our permission.
        </p>
      </LegalSection>

      <LegalSection title="No warranty">
        <p>
          This site and everything on it is provided "as is". We try to keep it accurate
          and available, but we do not guarantee it will be error-free, uninterrupted, or
          fit for any particular purpose.
        </p>
      </LegalSection>

      <LegalSection title="Limitation of liability">
        <p>
          To the extent permitted by law, Driscop is not liable for any indirect or
          consequential loss arising from your use of this site. Nothing in these terms
          limits or excludes our liability where it would be unlawful to do so, including
          for death or personal injury caused by our negligence, or for fraud.
        </p>
      </LegalSection>

      <LegalSection title="Third-party links">
        <p>
          This site may link to third-party sites, such as the ICO's website. We are not
          responsible for the content or practices of any site we don't operate.
        </p>
      </LegalSection>

      <LegalSection title="Changes to these terms">
        <p>
          We may update these terms as the site and our products evolve. Material changes
          will be reflected by updating the "Last updated" date at the top of this page.
        </p>
      </LegalSection>

      <LegalSection title="Governing law">
        <p>
          These terms are governed by the laws of England and Wales, and the courts of
          England and Wales have exclusive jurisdiction over any dispute arising from them.
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          Questions about these terms can be sent to{' '}
          <a href="mailto:hello@driscop.co.uk" className="text-blue-400 hover:text-blue-300">
            hello@driscop.co.uk
          </a>
          .
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
